import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Description from "./Description";
import dayjs from "dayjs";
import { Divider, Form, Spin } from "antd";
import { normalizeDateToLocalYear } from "../../../../../utils";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import JobDetails from "./JobDetails";
import EmploymentTerms from "./EmploymentTerms";
import {
  setActiveObj,
  setRefetchKey,
} from "../../../../../features/folder/folderSlice";
import JobDocTable from "./JobDocTable";

function DetailsList({ setactive }) {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
  const { docs } = useSelector((state) => state.folder);
  const { saving } = useSelector((state) => state.save);
  const handleCancel = async () => {
    await navigate("/recruitment/jobs-table");
  };
  const onFinish = async (data) => {
    data.jobId = activeObjJob?.jobId ? activeObjJob?.jobId : null;
    const cleanedDocs = docs?.filter((d) => d?.docName)?.map((d) => d?.docName);

    const res = await dispatch(
      save({
        ...data,
        jobDocs: cleanedDocs,
        url: "api/v1/jobs",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await dispatch(
        setActiveObj({ key: "job", data: res?.payload?.data?.result })
      );
      await setactive("2");
      await dispatch(setRefetchKey("2"));
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjJob,
    });
  }, [activeObjJob, form]);

  const initialFormValues = {
    ...activeObjJob,
  };

  return (
    <div className="dark_card py-[2rem]">
      <Form
        layout="vertical"
        ref={formRef}
        name="registration"
        onFinish={onFinish}
        scrollToFirstError
        form={form}
        // initialValues={initialFormValues}
        className="lg:w-[50rem] w-full"
      >
        <Description form={form} />
        <JobDetails form={form} />
        <EmploymentTerms form={form} />
        <JobDocTable />

        <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center gap-x-2">
            <div className="w-[150px]">
              <button
                key="back"
                type="button"
                onClick={handleCancel}
                className="cstm-btn-2"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn"
                disabled={saving}
              >
                {saving ? <Spin /> : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default DetailsList;
